import { RelevanceTestsService } from 'src/services/RelevanceTestsService';

export const mutateRelevanceTestDefinition = async (
    {
        accessToken,
        testDefinitionId,
        data,
        signal,
    }: App.RelevanceTestDefinitions.MutationVariables,
): Promise<Models.IngestConfigApi.RelevanceTests.RelevanceTestDefinition> => RelevanceTestsService
    .updateRelevanceTestDefinition(
        accessToken,
        testDefinitionId,
        data,
        signal,
    );
